import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/.dev/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/.dev/markdoc/tags.tsx'
import * as nodes from '/vercel/path0/.dev/markdoc/nodes.tsx'
import * as functions from '/vercel/path0/.dev/markdoc/functions.ts'
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Sign-in Screen\ndescription: Customize the sign-in screen of your app.\nvideo:\nslug: sign-in-screen\n---\n\nIf your app uses any kind of sign-in method then you can customize the way your sign-in screen looks by uploading your own background, logo, greeting & description.\n\n{% figure src=\"/docs/reference/ux/sign-in-screen/sign-in-1.png\" caption=\"\" /%}\n\n## Default sign-in screen\n\nYour sign-in screen will default to the settings you have configured in the appearance settings. To start customizing your sign-in screen visit Settings > Sign-in Screen. Here you can customize the background, add a logo, change the ‘Greeting’ text, and also the description.\n\n{% figure src=\"/docs/reference/ux/sign-in-screen/CleanShot 2023-07-05 at 10.53.32@2x.png\" caption=\"\" /%}\n\n## Text\n\nYou can change the greeting and the description in the **Text** section. You can play around with the **Style** option in the **Appearance** settings to achieve the right contrast between the background and the text.\n\n{% figure src=\"/docs/reference/ux/sign-in-screen/CleanShot 2023-06-27 at 11.23.34@2x.png\" caption=\"\" /%}\n\n## Branding\n\n{% callout title=\"Don't see custom branding options?\" %} \nYou may need to update your account. [Browse Glide's plans and find the right fit for you.](https://www.glideapps.com/pricing) \n{% /callout %}\n\n\nIn the **DESIGN** section, you can upload a logo and a background. The background image will replace the background accent color of your app, and your logo will replace the title at the top of this screen.\n\n{% figure src=\"/docs/reference/ux/sign-in-screen/CleanShot 2023-07-05 at 11.22.04@2x.png\" caption=\"\" /%}\n\n## User Agreement\n\nWe can add a **User Agreement** checkbox for users to tick before signing in to the app. Here we can also add links to any external pages where we might have terms, conditions, privacy policy, etc.\n\n{% figure src=\"/docs/reference/ux/sign-in-screen/CleanShot 2023-07-05 at 11.24.33@2x.png\" caption=\"\" /%}\n\n\n\n\n\n\n\n\n";
const filepath = "/reference/ux/sign-in-screen.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
